import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { map, take } from "rxjs/operators";
import { AuthSelectors } from "src/app/modules/auth/ngrx/auth.selectors.types";
import { APP_ROLES } from "src/app/modules/auth/shared/models/auth-roles";

export const CanAccessAuthenticated = () => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select("auth").pipe(
    take(1),
    map((authState) => {
      if (authState.isAuthenticated) {
        return true;
      } else {
        return router.createUrlTree(["/auth"]);
      }
    })
  );
};

export const CanAccessEWiz = () => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select("auth").pipe(
    take(1),
    map((authState) => {
      if (authState.profile.roles.indexOf(APP_ROLES.ewiz) !== -1) {
        return true;
      } else {
        return router.createUrlTree(["/auth"]);
      }
    })
  );
};

export const CanAccessEdgar = () => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select("auth").pipe(
    take(1),
    map((authState) => {
      if (authState.profile.roles.indexOf(APP_ROLES.edgar) !== -1) {
        return true;
      } else {
        return router.createUrlTree(["/auth"]);
      }
    })
  );
};

export const CanAccessHSM = () => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select("auth").pipe(
    take(1),
    map((authState) => {
      if (authState.profile.roles.indexOf(APP_ROLES.hsm) !== -1) {
        return true;
      } else {
        return router.createUrlTree(["/auth"]);
      }
    })
  );
};

export const CanAccessIntelligent = () => {
  const router = inject(Router);
  const store = inject(Store);

  return store.select(AuthSelectors.roles).pipe(
    take(1),
    map((roles) => {
      if (roles.includes(APP_ROLES.intelligent)) {
        return true;
      } else {
        return router.createUrlTree(["/auth"]);
      }
    })
  );
};
